// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "contentWrapper-172ii";
var _3 = "paper-1v74B";
export { _1 as "__esModule", _2 as "contentWrapper", _3 as "paper" }
export default { "__esModule": _1, "contentWrapper": _2, "paper": _3 }
